import { OBJECT_KEY_DELIMITER } from '../constants';
export function createObjectKey(taskID: string, videoId: string, frameIndex: number, annotationId: string): string {
  return [taskID, videoId, String(frameIndex), annotationId].join(OBJECT_KEY_DELIMITER);
}